import React from 'react';

import { Link } from '@auspost/postmaster-react';

import CameraIcon from 'assets/camera.svg';
import { config } from 'config/env-config';
import { attemptedDeliveryPhotos } from 'config/track-config';
import { trackInteraction } from 'store/analytics/analytics.thunks';

import { useAppDispatch } from '../../../../store/store';
import { useArticles } from '../../hooks/shipment.hooks';
import DownloadAppModal from '../DownloadAppModal/DownloadAppModal';
import ExtraContentCta from '../ExtraContentCta/ExtraContentCta';

import styles from './ViewAttemptedDeliveryCta.module.scss';

const ViewAttemptedDeliveryCta: React.FC = () => {
  const dispatch = useAppDispatch();
  const articles = useArticles();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const branchIoLink = config.env.branchIoAttdelLink;
  const modalContent =
    "Download the AusPost app to view attempted delivery photos safely. Your privacy matters, and the app ensures sensitive images – like your home's location – are protected.";

  const articleId = articles.length === 1 ? articles[0].articleId : '';

  const branchDeepLink = `auspost%3A%2F%2Ftrackdetails%2F${articleId}%2Fimage%3Ftype%3Dattempteddelivery`;

  const handleOnClick = () => {
    dispatch(trackInteraction('view attempted delivery photo'));
    setIsModalOpen(true);
  };

  const handleFaqLink = () => {
    dispatch(trackInteraction('attempted delivery faq link'));
  };

  return (
    <div className={styles.attemptedDeliveryCtaWrapper}>
      <ExtraContentCta
        icon={<CameraIcon aria-hidden />}
        buttonText='View attempted delivery photo'
        onClick={handleOnClick}
        className={styles.ctaExtra}
      >
        <DownloadAppModal
          isOpen={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
          branchIoLink={branchIoLink}
          branchDeepLink={branchDeepLink}
          modalContent={modalContent}
        />
      </ExtraContentCta>
      <Link
        target='_blank'
        onClick={handleFaqLink}
        href={attemptedDeliveryPhotos}
        className={styles.attemptedDeliveryFaqLink}
      >
        Learn more about attempted delivery photos
      </Link>
    </div>
  );
};

export default ViewAttemptedDeliveryCta;
